import { Grid } from "@chakra-ui/layout";
import { useToast } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { InputControl, SubmitButton } from "formik-chakra-ui";
import { Link } from "react-router-dom";
import { useSendMailForgotPasswordMutation } from "../../store/api";

import {
  Flex,
  Box,
  Stack,
  Heading,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

const ForgotPassword = () => {
  const toast = useToast();

  const [sendMail, { isLoading, data, isError, error }] =
    useSendMailForgotPasswordMutation();
  if (isError) {
    toast({
      title: (error as any).data.message,
      status: "error",
      duration: 5000,
    });
  }

  return (
    <Formik
      initialValues={{ email: "" }}
      onSubmit={(values, { setSubmitting, resetForm, setErrors }) => {
        sendMail({ ...values}).
        unwrap().
        then((res: any) => {
          if (res?.success) {
            toast({
              title: res?.message || "Reset Password link sent. Please verify your email",
              status: "success",
              duration: 5000,
            });
            resetForm();
          } else if (!res?.success) {
            toast({
              title: res?.error?.data?.message || "Reset password email sending failed",
              status: "error",
              duration: 5000,
            });
            setErrors(res?.error?.data);
          }
        }).catch(err => {
          toast({
            title: err?.data?.message || "Reset password email sending failed",
            status: "error",
            duration: 5000,
          });
        });
      }}
    >
      <Form>
        <Flex
          minH={'100vh'}
          align={'center'}
          justify={'center'}
          bg={useColorModeValue('gray.50', 'gray.800')}>
          <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
            <Stack align={'center'}>
              <Heading color="teal" fontSize={'4xl'}>Send reset password link</Heading>
            </Stack>
            <Box
              rounded={'lg'}
              bg={useColorModeValue('white', 'gray.700')}
              boxShadow={'lg'}
              p={8}>
              <Stack spacing={4}>
                <InputControl
                  isRequired
                  name="email"
                  label="Email"
                  inputProps={{
                    type: "email",
                    placeholder: "Enter Email...",
                  }}
                />

                <Stack spacing={10}>
                  <SubmitButton _hover={{
                    bg: 'blue.500',
                  }} isLoading={isLoading}>Send Mail</SubmitButton>
                  <Flex justify="flex-end">
                    <Text as={Link} to="/signin" fontSize="small" color="teal">
                      Back to Sign in
                    </Text>
                  </Flex>
                </Stack>
              </Stack>
            </Box>
          </Stack>
        </Flex>
      </Form>
    </Formik>
  );
};

export default ForgotPassword;


